module.exports = __webpack_public_path__ + "static/4-4b3f5085421e30f707d6940e476faa1c.jpeg";